import { render, staticRenderFns } from "./TermsAndConditionsPage.vue?vue&type=template&id=425c637a"
import script from "./TermsAndConditionsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./TermsAndConditionsPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TermsAndConditionsPage.vue?vue&type=style&index=0&id=425c637a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports